import React from 'react'
import moment from 'moment'
import Modal from 'react-modal'
import update from 'immutability-helper'

import NavLink from '../Routes/NavLink'
import InvoiceStatusSelect from '../../helpers/Invoices/InvoiceStatusSelect'
import { documents } from '../../core/controllers/Documents';
import { invoices } from '../../core/controllers/Invoices';
import { modal } from '../../core/utilities/modal';
import { invoice } from '../../core/controllers/Invoice';
import { modalStyles } from '../../core/controllers/ModalStyles';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import VendorSelect from '../../helpers/Vendor/VendorSelect';
import { dropZone } from '../../core/utilities/DropZoneHandler';
import DropzoneComponent from 'react-dropzone-component';

const Attachment = ({attachment, deleteFunc}) => {
    return (
        <attachment key={attachment.id}>
            <div class={attachment.content_type == 'pdf' ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xs-12" : "col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6"}>
                <span class="deleteDocument" onClick={deleteFunc.bind(this, attachment)}><i class="pe-7s-close"></i></span>
                <a href={attachment.url} target="_blank">
                    { attachment.content_type == 'pdf' ? (
                        <object width="100%" height="500" data={attachment.url} type="application/pdf"></object>
                    ) : (
                        <img src={attachment.url} width="100px" height="100px" />
                    )}
                </a>
            </div>
        </attachment>
    );
};

export default class InvoiceList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoices: {},
            invoiceId: 0,
            showModal: false,
            newInvoice: false,
            orderId: this.props.orderId,
            invoiceData: {
                invoice_title: '',
                invoice_description: '',
                invoice_amount: 0,
                time_worked_hours: 0,
                invoice_status: 'Submitted',
                work_order_id: 0,
                vendor_id: 0,
                invoice_id: 0,
                attachments: null
            },
        }
    }

    componentDidMount() {
        var self = this;
        if(this.state.orderId != 'new') {
            invoices.getInvoicesWithOrderId(this.state.orderId, function(response){
                if(response.data.length > 0) {
                    self.processInvoices(response);
                }
            });
        }

        dropZone.setup(this, 'work_order_invoice', this.state.invoiceId);
    }

    triggerUpload(invoice_id, type, callback = null) {
        var self = this;
        if(invoice_id != 0) {
            dropZone.setup(this, 'work_order_invoice', invoice_id, true);
        }

        dropZone.upload(type, function() {
            if (callback) {
                callback();
            }
        });
    }

    handleOpenModal(type) {
        if (type == "add_invoice") {
            this.setState ({
                newInvoice: true,
                invoiceId: 0,
                invoiceData: {
                    invoice_title: '',
                    invoice_description: '',
                    invoice_amount: 0,
                    time_worked_hours: 0,
                    invoice_status: 'Submitted',
                    work_order_id: 0,
                    vendor_id: 0,
                    invoice_id: 0,
                    attachments: null
                }
            });
        }
        this.setState({ showModal: true });
    }

    handleCloseModal(hasChanged) {
        if (hasChanged == true) {
            this.refresh();
        }
        this.setState({ showModal: false });
    }

    processInvoices(invoices) {
        this.setState({
            invoices: invoices.data ? invoices.data : {},
            newInvoice: false,
            invoiceId: 0
        });
    }

    refresh() {
        var self = this;
        invoices.getInvoicesWithOrderId(this.state.orderId, function(response){
            self.processInvoices(response);
        });

        this.setState ({
            invoices: {},
            newInvoice: false,
            invoiceId: 0,
            invoiceData: update(this.state.invoiceData, {
                invoice_title: {$set: ''},
                invoice_description: {$set: ''},
                invoice_amount: {$set: 0},
                time_worked_hours: {$set: 0},
                invoice_status: {$set: 'Submitted'},
                work_order_id: {$set: 0},
            })
        })
    }

    handleTitleChange(e){
        this.setState({
            invoiceData: update(this.state.invoiceData, {
                invoice_title: {$set: e.target.value
                }}
            )
        });
    }

    handleDescriptionChange(e) {
        this.setState({
            invoiceData: update(this.state.invoiceData, {
                invoice_description: {$set: e.target.value
                }}
            )
        });
    }

    formatAmount(value) {
        value = value.replace(',', '');
        if(isNaN(value) || value === 0) {
            value = 0;
        } else {
            value = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(value)
        }

        return value;
    }

    handleAmountChange(e){
        this.setState({
            invoiceData: update(this.state.invoiceData, {
                invoice_amount: {$set: e.target.value
                }}
            )
        });
    }

    handleTimeWorkedChange(e){
        this.setState({
            invoiceData: update(this.state.invoiceData, {
                time_worked_hours: {$set: e.target.value
                }}
            )
        });
    }

    handleStatusChange(e){
        this.setState({
            invoiceData: update(this.state.invoiceData, {
                invoice_status: {$set: e.target.value
                }}
            )
        });
    }

    handleVendorChange(e) {
        this.setState({
            invoiceData: update(this.state.invoiceData, {
                vendor_id: {$set: e.target.value}
            })
        });
    }

    handleUpdateInvoice(e){
        if(!this.validate()) {
            return;
        }
        var self = this;
        invoice.updateInvoice(this.state.invoiceData, function(response) {
            self.triggerUpload(self.state.invoiceId, "work_order_invoice", function(response) {
                modal.showInfo("Successfully added file!", "success", "top", "center");
            });
            if(self.state.orderId != 'new') {
                invoices.getInvoicesWithOrderId(self.state.orderId, function(response){
                    if(response.data.length > 0) {
                        self.processInvoices(response);
                    }
                });
            }
            self.handleCloseModal(true);
        });
    }

    handleSaveInvoice(e){
        if(!this.validate()) {
            return;
        }
        var self = this;

        invoice.saveInvoice(this.state.invoiceData, this.state.orderId, function(response) {
            self.triggerUpload(response.data.invoice_id, "work_order_invoice", function(response) {
                modal.showInfo("Successfully added file!", "success", "top", "center");
            });
            if(self.state.orderId != 'new') {
                invoices.getInvoicesWithOrderId(self.state.orderId, function(response){
                    if(response.data.length > 0) {
                        self.processInvoices(response);
                    }
                });
            }
            self.handleCloseModal(true);
        });
    }

    handleDeleteInvoice(e){
        var self = this;
        modal.showDangerModalWithOK("Are you sure?","You are about to delete this invoice.", "Yes, Delete");
        jQuery(".move-on").on('click',function() {
            invoice.deleteInvoice(self.state.invoiceId, function() {
                if(self.state.orderId != 'new') {
                    invoices.getInvoicesWithOrderId(self.state.orderId, function(response){
                        if(response.data.length > 0) {
                            self.processInvoices(response);
                        }
                    });
                }
                self.handleCloseModal(true);
            });
        })
    }

    validate() {
        const invoiceData = this.state.invoiceData;
        const invoiceAmount = invoiceData.invoice_amount.toString().replace(',', '').replace('.', '');

        if(invoiceData.invoice_description.length == 0) {
            modal.showInfo("Please supply an invoice description.", "warning", "top", "center");
            return false;
        }
        if(invoiceData.invoice_title.length == 0) {
            modal.showInfo("Please supply an invoice title.", "warning", "top", "center");
            return false;
        }
        if (invoiceAmount == null || invoiceAmount <= 0) {
            modal.showInfo("Please supply an invoice amount.", "warning", "top", "center");
            return false;
        } else if (isNaN(invoiceAmount)) {
            modal.showInfo("Please enter a valid invoice amount.", "warning", "top", "center");
            return false;
        }

        return true;
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatDate(cell, row) {
        return moment.utc(cell).local().format('DD MMM YYYY, h:mm A');
    }

    formatAmountColumn(cell, row) {
        return "$" + cell;
    }

    didSelectRow(row) {
        var self = this;

        this.setState ({
            newInvoice: false,
            invoiceId: row.invoice_id,
            invoiceData: {
                invoice_title: '',
                invoice_description: '',
                invoice_amount: 0,
                time_worked_hours: 0,
                invoice_status: 'Submitted',
                work_order_id: 0,
                vendor_id: 0,
                invoice_id: 0,
                attachments: null
            }
        });

        invoice.getInvoice(row.invoice_id, function(response) {
            var invoiceAmount = response.data.invoice_amount.toString().replace(',', '').replace('.', '');
            if (invoiceAmount == null || invoiceAmount <= 0) {
                invoiceAmount = 0
                modal.showInfo("Something wrong while retrieving the invoice amount.", "danger", "top", "center");
            } else if (isNaN(invoiceAmount)) {
                invoiceAmount = 0
                modal.showInfo("Something wrong while retrieving the invoice amount.", "danger", "top", "center");
            } else {
                invoiceAmount = response.data.invoice_amount //Reset response data
            }
            response.data.invoice_amount = invoiceAmount;
            self.setState({
                invoiceData: response.data
            })
        });
        this.setState({ showModal: true });
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    handleDeleteDocument(attachment) {
        var self = this;
        documents.deleteDocument(attachment.id, function() {
            invoice.getInvoice(self.state.invoiceId, function(response) {
                var invoiceAmount = response.data.invoice_amount.toString().replace(',', '').replace('.', '');
                if (invoiceAmount == null || invoiceAmount <= 0) {
                    invoiceAmount = 0
                    modal.showInfo("Something wrong while retrieving the invoice amount.", "danger", "top", "center");
                } else if (isNaN(invoiceAmount)) {
                    invoiceAmount = 0
                    modal.showInfo("Something wrong while retrieving the invoice amount.", "danger", "top", "center");
                } else {
                    invoiceAmount = response.data.invoice_amount //Reset response data
                }
                response.data.invoice_amount = invoiceAmount;
                self.setState({
                    invoiceData: response.data
                })
            });
        });
    }

    renderAttachments(attachments) {
        var self = this;
        if (attachments !== null) {
            if(attachments.length > 0) {
                var attachmentsLength = attachments.length
                for (var i = 0; i < attachmentsLength; i++) {
                    if (attachments[i].content_type == "pdf") {
                        var temp = attachments[i]
                        attachments.splice(i, 1);
                        attachments.push(temp)
                    }
                }
                return attachments.map((attachment, index) => (
                    <Attachment key={index} attachment={attachment} deleteFunc={self.handleDeleteDocument.bind(self)}/>
                ));
            }
        }
    }

    formatVendor(cell, row) {
        return (
            <span onClick={this}>
                <NavLink to={'/payables/vendors/' + row.vendor_id}>{row.vendor_name}</NavLink>
            </span>
        )
    }

    render(){
        var self = this;
        const invoices = this.state.invoices;
        const newInvoice = this.state.newInvoice;
        const invoiceData = this.state.invoiceData;
        const vendorId = invoiceData.vendor_id;
        const attachments = this.renderAttachments(invoiceData.attachments);
        const options = {
            onRowClick: this.didSelectRow.bind(this)
        };

        return (
            <div>
                <div class="content">
                    {invoices.length > 0 ? (
                    <div>
                        <BootstrapTable data={invoices} version='4' striped search pagination hover options={options}>
                            <TableHeaderColumn dataField='invoice_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='invoice_title' dataSort={ true }>Title</TableHeaderColumn>
                            <TableHeaderColumn dataField='invoice_status' dataSort={ true }>Status</TableHeaderColumn>
                            <TableHeaderColumn dataField='invoice_amount' dataFormat={this.formatAmountColumn} dataSort={ true }>Amount</TableHeaderColumn>
                            <TableHeaderColumn dataField='vendor_name' dataFormat={this.formatVendor.bind(this.stopSelectRow)}  dataSort={ true }>Vendor</TableHeaderColumn>
                            <TableHeaderColumn dataField='created_at' dataFormat={this.formatDate} dataSort={ true }>Submitted</TableHeaderColumn>
                        </BootstrapTable>
                        <button type="button" id="add_invoice_modal" autoComplete="off" class="btn btn-secondary btn-info btn-fill pull-right" onClick={this.handleOpenModal.bind(this, "add_invoice")}>
                            Add Invoice
                        </button>
                        <div class="clearfix"></div>
                    </div>
                    ) : (
                    <div style={{textAlign: "center"}}>
                        <div class="row">
                            <div class="main-page-header-row col-md-12">
                                <div class="row">
                                    <span class="main-page-header-title" style={{color: "black", fontWeight: "normal"}}>No Invoices Yet</span>
                                </div>
                                <div class="row" style={{marginTop: "10px"}}>
                                    <button type="button" id="add_invoice_modal" autoComplete="off" class="btn btn-secondary btn-info btn-fill" onClick={this.handleOpenModal.bind(this, "add_invoice")}>
                                        Add Invoice
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
                <Modal
                    isOpen={this.state.showModal}
                    onRequestClose={this.handleCloseModal.bind(this, false)}
                    style={modalStyles.getModalStyles()}
                    ariaHideApp={false}
                >
                <div class="row">
                    <div class="modal-exit-icon pull-right" onClick={this.handleCloseModal.bind(this, false)}></div>
                </div>
                {newInvoice == true ? (
                    <div class="row">
                        <div class="modal-header">Add an Invoice</div>
                    </div>
                ) : (
                    <div class="row">
                        <div class="modal-header">{invoiceData.invoice_title}</div>
                    </div>
                )}
                <div class="row">
                    <div class="modal-section-title col-md-12">Invoice Information</div>
                    {newInvoice == false && (
                    <div>
                        <div class="row">
                            <div class="modal-section-note-title">Date Submitted</div>
                        </div>
                        <div class="row">
                            <div class="modal-section-note-date">{moment.utc(invoiceData.created_at).local().format('DD MMM YYYY, h:mm A')}</div>
                        </div>
                    </div>
                    )}
                </div>
                <form>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <div class="form-group">
                                <label>Title*</label>
                                <input type="text" value={invoiceData.invoice_title} class="form-control" name="title" placeholder="Invoice Title" id="ordertitle" onChange={this.handleTitleChange.bind(this)}/>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <div class="form-group">
                                <label>Status</label>
                                <div class="clearfix"></div>
                                <InvoiceStatusSelect padding={0} columnSize={0} title="" sortID={invoiceData.invoice_status} onChange={this.handleStatusChange.bind(this)}/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <div class="form-group">
                                <label>Amount*</label>
                                <div class="form-group has-feedback">
                                    <input type="text" value={invoiceData.invoice_amount} class="form-control input-group-dollar-addon" name="amount" placeholder="Invoice Amount" id="invoiceamount" onChange={this.handleAmountChange.bind(this)}/>
                                    <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <div class="form-group">
                                <label>Hours Worked</label>
                                <input type="number" value={invoiceData.time_worked_hours} class="form-control" name="timeworked" placeholder="Invoice Hours Worked" id="timeworked" onChange={this.handleTimeWorkedChange.bind(this)}/>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <div class="form-group">
                                <label>Does this invoice belong to a vendor?</label>
                                <VendorSelect columnSize={0} sortID={vendorId} title="" onChange={this.handleVendorChange.bind(this)}/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <div class="form-group">
                                <label for="invoice-description">Description*</label>
                                <textarea rows="8" cols="80" class="form-control" placeholder="Describe the invoice" value={invoiceData.invoice_description} onChange={this.handleDescriptionChange.bind(this)}/>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <div class="form-group">
                                <label>Upload Invoice Document</label>
                                <div class="content">
                                    <div style={{textAlign: "center"}}>
                                        <DropzoneComponent config={this.state.dropZoneConfig}
                                            eventHandlers={this.state.dropZoneEventHandlers}
                                            djsConfig={this.state.dropZoneJSConfig} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" style={{marginBottom: '15px'}}>
                            <div class="content">
                            { attachments == null ? (
                                null
                            ) : (
                                attachments
                            )}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="content">
                        { newInvoice === true ? (
                        <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                            <button type="button" id="add-invoice" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.handleSaveInvoice.bind(this)}>
                                Create Invoice
                            </button>
                        </div>
                        ) : (
                        <div class="col-md-12">
                            <div class="col-md-3 col-md-offset-2 col-sm-3 col-sm-offset-2 col-xs-6" style={{padding: 0}}>
                                <button type="button" id="delete-invoice" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.handleDeleteInvoice.bind(this)}>
                                    Delete Invoice
                                </button>
                            </div>
                            <div class="col-md-3 col-md-offset-1 col-sm-3 col-sm-offset-1 col-xs-6" style={{padding: 0}}>
                                <button type="button" id="update-invoice" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.handleUpdateInvoice.bind(this)}>
                                    Update Invoice
                                </button>
                            </div>
                        </div>
                        )}
                        <div class="clearfix"></div>
                        </div>
                    </div>
                </form>
                </Modal>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Invoices/InvoiceList.jsx